import Link from 'gatsby-link';
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import PersonCardImageComponent from '../persons/subcomponents/personCardImage.component';

const PersonComponent = ({
    name,
    title,
    email,
    phone,
    image,
    slug,
    onVisible,
}) => (
    <Link to={`/person/${slug}`} css={teaserDetailsWrapper}>
        <PersonCardImageComponent image={image} />
        <div className="t14 name">{name}</div>
        <div className="t14 title o5">{title}</div>
        <div className="t14 email">{email}</div>
        <div className="t14 phone">{phone}</div>
    </Link>
);

const teaserDetailsWrapper = css`
    display: flex;
    flex-direction: column;
    height: 100%;
    text-decoration: none;
    .name {
        margin-top: 30px;
    }
    .title {
        margin-bottom: 1.15em;
    }
    .email {
        margin-bottom: 0.25em;
        margin-top: auto;
    }
`;

export default PersonComponent;
